"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usa_validation_1 = __importDefault(require("@uswds/uswds/js/usa-validation"));
function Validation({ children, heading, id, requirements }) {
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const containerEl = containerRef.current;
        if (!containerEl)
            return;
        // call USWDS's `on` function to initialize the component
        usa_validation_1.default.on(containerEl);
        // on dismount, call USWDS's `off` function to cleanup the component
        return () => {
            usa_validation_1.default.off(containerEl);
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "bah-uswds-validation", ref: containerRef, children: [(0, jsx_runtime_1.jsx)("div", { className: "usa-alert usa-alert--info usa-alert--validation", children: (0, jsx_runtime_1.jsxs)("div", { className: "usa-alert__body", children: [(0, jsx_runtime_1.jsx)("h3", { className: "usa-alert__heading", children: heading }), (0, jsx_runtime_1.jsx)("ul", { className: "usa-checklist", id: id, children: requirements.map(({ text, validator }) => ((0, jsx_runtime_1.jsx)("li", { className: "usa-checklist__item", "data-validator": validator, children: text }, `${id}--${validator}`))) })] }) }), children] }));
}
exports.default = Validation;
